import React from 'react';
import { BENEFITS_KEY } from '@/router/Permissions';
import BenefitsManagement from '../benefitsManagement';

const shopBenefitSections = [
  {
    title: '店铺权益',
    benefitsType: 'SHOP',
    fetchErrorText: '获取店铺权益失败',
    showDelete: false,
    showAddCard: false,
    allowEdit: false,
    allowDelete: false,
  },
];

const ShopBenefitsManagement: React.FC = () => (
  <BenefitsManagement
    pageTitle="店铺权益"
    modalTitlePrefix="店铺权益"
    sections={shopBenefitSections}
    switchPermissionKey={BENEFITS_KEY.SHOP_SWITCH}
  />
);

export default ShopBenefitsManagement;
